<template>
  <div
    class="permissions-category-upsert"
    v-if="hasAdminRole"
  >
    <permissions-table />
  </div>
</template>

<script>
  import PermissionsTable from '@/appComponents/permissions/PermissionsTable'

  export default {
    components: {
      PermissionsTable,
    },
    computed: {
      hasAdminRole() {
        let r = this.$store.getters.userRoles
        let p = this.$store.getters.hasAdminEditRolesPermission
        return r && r.hasAdminRole() && p
      },
    },
  }
</script>

<style lang="scss">
  .permissions-category-upsert {
    width: 90%;
    margin: 0 auto;
    margin-top: 3em;
  }
</style>



// WEBPACK FOOTER //
// PermissionsView.vue?53112332